import { datadogRum } from '@datadog/browser-rum';

export const dataDogErrorHelperRoot = (
  ...params: Parameters<typeof datadogRum.addError>
) => {
  datadogRum.addError(...params);
};
